import { run } from '@cycle/run';
import { makeHTTPDriver } from '@cycle/http';
import { createCycleMiddleware } from 'redux-cycles';
import { createLogger } from 'redux-logger';
import main from '../cycles';
import { createBrowserHistory } from 'history';
import reducers from '../reducers';
import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const logger = createLogger({});

const middleWare = [];

const cycleMiddleware = createCycleMiddleware();

const { makeActionDriver, makeStateDriver } = cycleMiddleware;

middleWare.push(cycleMiddleware);

if (process.env.NODE_ENV === 'development') {
    middleWare.push(logger);
} else {
}
const persistConfig = {
    key: 'root',
    version: 1,
    storage: storage,
    whitelist: ['applicationSettings'],
};

const reducer = persistReducer(persistConfig, reducers);

export const store = configureStore({
    reducer,
    middleware: middleWare,
    devTools: process.env.NODE_ENV !== 'production',
});

run(main, {
    ACTION: makeActionDriver(),
    STATE: makeStateDriver(),
    HTTP: makeHTTPDriver(),
});

export const history = createBrowserHistory({
    basename: process.env.REACT_APP_UI_VPATH,
});

export const persistor = persistStore(store);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export default store;
